import BaseRequest from '../_baseRequest';

const baseUrl = 'Report/ReportByUrl';

const Search = {
  searchByWord: (pattern) => {
    const req = new BaseRequest();
    return req.makeRequest(
      {},
      { url: `/report_search_free?p_rep_par=${pattern}` },
      null,
      'post',
      '/api/' + baseUrl,
      null,
      null,
      null,
      false,
      false,
      'AZURE'
    );
  }
};

export default Search;
